import {
  IsArray,
  IsNotEmpty,
  IsUUID,
  IsOptional,
  IsBoolean,
} from 'class-validator';

import { DateRange } from '@app/gen/settings';

export class CreateSubstituteDto {
  @IsUUID()
  @IsNotEmpty()
  substituteId: string;

  @IsUUID()
  @IsNotEmpty()
  employeeId: string;

  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @IsArray()
  @IsNotEmpty()
  eventTypes: string[];

  @IsArray()
  @IsOptional()
  dates?: DateRange[];

  @IsBoolean()
  @IsOptional()
  isManagerAbsencePeriod?: boolean;
}
